/** AWS's identity-monitor fix generators: how to remediate a finding, as
 * opposed to `./index.ts`'s monitors, which describe what is risky.
 * `./index.ts`'s `accountFixGenerator` merges this with
 * `./gcloud-fix-generators.ts`'s contribution, selecting by integration at
 * read time (`monitor.fix?.[integration]`). */
import type { Node } from "../../../../graph/types.ts";
import type { AssessmentNodes } from "../../../../types/assessment/data/index.ts";
import { arnInfo } from "../../aws-arn.ts";

export const awsAccountFixGenerator = (status: "disabled" | "enabled") => ({
  aws: {
    description: `${
      status === "disabled" ? "Re-enable" : "Disable"
    } these IAM roles by running these commands in AWS Cloud Shell.`,
    type: "shell" as const,
    generate: (node: Node<AssessmentNodes, "identity">) => {
      const awsPartition = arnInfo(node.key).partition;
      return `aws iam ${
        status === "disabled" ? "detach-role-policy" : "attach-role-policy"
      } --role-name ${
        node.data.label
      } --policy-arn arn:${awsPartition}:iam::aws:policy/AWSDenyAll`;
    },
  },
});
